import { mockData } from './Mock';
import { ProcessStep } from '../../models/SuperThemProcess';

// Mock数据
const mockProcessSteps: ProcessStep[] = [
  {
    id: '1',
    type: 'agree',
    title: '用户协议',
    content: '请仔细阅读并同意我们的用户协议条款',
    order: 1,
    confirmButtonText: '同意',
    cancelButtonText: '不同意'
  },
  {
    id: '2',
    type: 'input',
    title: '确认条款',
    content: '请输入"我已阅读并同意所有条款"来确认',
    requiredText: '我已阅读并同意所有条款',
    order: 2,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  },
  {
    id: '3',
    type: 'agree',
    title: '隐私政策',
    content: '请同意我们的隐私政策',
    order: 3,
    confirmButtonText: '同意',
    cancelButtonText: '不同意'
  }
];

// 设置Mock数据
mockData.set("getAllProcessSteps", mockProcessSteps);
mockData.set("addProcessStep", 4);
mockData.set("deleteProcessStep", true); 